import React, { useRef } from "react";
import { TextInput } from "react-admin";
import { useForm } from "react-final-form";

export const TenantDomainNameInput = (props: any) => {
  const form = useForm();
  const adminEmailRef = useRef<string>();

  return (
    <TextInput
      {...props}
      onChange={(
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      ) => {
        const adminEmailFieldValue = form.getFieldState("adminEmailAddress")
          ?.value;
        if (
          adminEmailFieldValue &&
          adminEmailFieldValue !== adminEmailRef.current
        ) {
          // Don't set any value if the admin email field already has a user-supplied value
          return;
        }

        adminEmailRef.current = `admin@${e.target.value}`.toLocaleLowerCase();
        form.change("adminEmailAddress", adminEmailRef.current);
      }}
    />
  );
};
